const products = [
  {
    title: "CelebHaters",
    description: "A social platform for celebrity hot takes and opinions",
    link: "https://celebhaters.com",
    icon: "🌐"
  },
  {
    title: "hotgoss",
    description: "An open-source npm package for gossip-style data",
    link: "https://www.npmjs.com/package/hotgoss",
    icon: "📦"
  }
];

export default products;
